export default "__VITE_ASSET__JvjsLDEe__"